import { createStore } from 'redux';
import rootReducer from './reducers/index';
import { createBrowserHistory } from 'history';

export const history = createBrowserHistory();

export const store = createStore(rootReducer);
